import React from "react";

function MobileIcon() {
  return (
    <div>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="18"
        height="24"
        viewBox="0 0 18 24"
        fill="none"
      >
        <path
          d="M0.75 3C0.75 1.34531 2.09531 0 3.75 0H14.25C15.9047 0 17.25 1.34531 17.25 3V21C17.25 22.6547 15.9047 24 14.25 24H3.75C2.09531 24 0.75 22.6547 0.75 21V3ZM6.75 21C6.75 21.4125 7.0875 21.75 7.5 21.75H10.5C10.9125 21.75 11.25 21.4125 11.25 21C11.25 20.5875 10.9125 20.25 10.5 20.25H7.5C7.0875 20.25 6.75 20.5875 6.75 21ZM14.25 3H3.75V18H14.25V3Z"
          fill="#0055A4"
        />
      </svg>
    </div>
  );
}

export default MobileIcon;
